<template lang="pug">
v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' :items='ordenes' :search='search' sort-by='numOrdenCompra')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Ordenes de Compra
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
        template(v-slot:item.action='{ item }')
          v-icon.mr-2( color='warning' @click='editItem(item)') mdi-pencil
        template(v-slot:no-data)
          h1 No hay ordenes de compras registradas

    v-dialog(v-model='dialog' persistent max-width='80%')
      v-card
        v-card-title
          span.headline Chequear Orden de compra
        v-card-text
          v-container
            v-row
              v-col(cols='12' sm='6' md='6')
                v-text-field(dense outlined readonly  label='Numero' v-model='editedItem.numOrdenCompra')
              v-col(cols='12' sm='6' md='6')
                v-text-field(dense outlined readonly label='Proveedor' v-model='editedItem.idProveedor.nombre')
            v-row
                v-data-table.elevation-1(:headers='header2' :items='editedItem.productos')
                  template(v-slot:item='props')
                    tr
                    td {{props.item.idProducto}}
                    td {{props.item.cantidadPedido}}
                    //- para la entrada
                    td
                      v-text-field(autocomplete="off" dense outlined type='number' @keyup='probando(props.item)' v-model.number='props.item.cantidadLlegado')
          v-card-actions
            v-spacer
            v-btn(color='error' small='' dark='' @click='close')
              v-icon mdi-close
              | Cancelar
            v-btn(color='success' small='' dark='' @click='save')
              v-icon mdi-content-save
              | Guardar
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    dialog: false,
    headers: [
      { text: 'Numero de Orden de Compra', value: 'numOrdenCompra' },
      { text: 'Proveedor', value: 'idProveedor.nombre' },
      { text: 'Fecha de emision', value: 'fechaEmision' },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    header2: [
      { text: 'Producto' },
      { text: 'Cant. solicitada' },
      { text: 'Cant. llegada' }
    ],
    search: '',
    editedIndex: -1,
    permisosRuta: {},
    ordenes: [],
    editedItem: {
      idProveedor: '',
      productos: [],
      selecProductosHijo: [],
      idUsuario: ''
    },
    defaultItem: {
      idProveedor: '',
      productos: [],
      selecProductosHijo: [],
      idUsuario: ''
    }
  }),

  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(
    //   permiso => permiso.ruta == "Producto"
    // );
  },

  methods: {
    initialize () {
      this.listarOrdenes()
    },

    listarOrdenes () {
      Api.get('/ordenCompra')
        .then(res => {
          this.ordenes = res.data
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    editItem (item) {
      this.editedIndex = this.ordenes.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.editedItem.productos = []
      }, 300)
    },

    save () {
    },

    probando (val) {
      if (val.cantidadLlegado > val.cantidadPedido) {
        val.cantidadLlegado = val.cantidadPedido
      }
    }
  }
}
</script>
